
/* MIBBLO - Mostrar botón Previsualizar solo tras interactuar en mobile */
document.addEventListener("teeinblue-event-component-injected", function () {

  if (window.innerWidth > 767) return;

  const formActions = document.querySelector('.tee-form-actions');

  const customizationForm = document.querySelector('.tee-customization-form');

  if (!formActions || !customizationForm) return;

  if (formActions.dataset.mibbloPreviewStickyInit === "1") return;

  formActions.dataset.mibbloPreviewStickyInit = "1";

  let userInteracted = false;

  function updateStickyPreview() {

    if (!userInteracted) {

      formActions.classList.remove('mibblo-preview-active');

      return;

    }

    const rect = customizationForm.getBoundingClientRect();

    const inZone = rect.top < window.innerHeight && rect.bottom > 720;

    if (inZone) {

      formActions.classList.add('mibblo-preview-active');

    } else {

      formActions.classList.remove('mibblo-preview-active');

    }

  }

  function activateStickyPreview() {

    userInteracted = true;

    updateStickyPreview();

  }

  customizationForm.addEventListener('click', activateStickyPreview, { once:true });

  customizationForm.addEventListener('input', activateStickyPreview, { once:true });

  customizationForm.addEventListener('change', activateStickyPreview, { once:true });

  window.addEventListener('scroll', updateStickyPreview, { passive:true });

  window.addEventListener('resize', updateStickyPreview);

});



// MODAL SHIPPING (hover)

document.addEventListener("DOMContentLoaded", function () {
  var openModal = document.getElementById("open-shipping-modal");
  var modal = document.getElementById("shipping-modal");
  var closeModal = modal?.querySelector(".shipping-modal-close");

  // Salir si no hay modal o disparador
  if (!openModal || !modal || !closeModal) return;

  var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints;

  function showModal() {
    modal.style.display = "block";
  }

  function hideModal() {
    modal.style.display = "none";
  }

  if (isTouchDevice) {
    // MÓVIL: Abrir con clic
    openModal.addEventListener("click", function (e) {
      e.preventDefault();
      showModal();
    });

    // MÓVIL: Cerrar al hacer clic fuera
    window.addEventListener("click", function (e) {
      if (modal.style.display === "block" &&
          !modal.contains(e.target) &&
          e.target !== openModal) {
        hideModal();
      }
    });

    // MÓVIL: Cerrar al hacer scroll
    window.addEventListener("scroll", function () {
      if (modal.style.display === "block") {
        hideModal();
      }
    }, { passive: true });

  } else {
    // ESCRITORIO: Abrir con hover
    openModal.addEventListener("mouseenter", showModal);

    openModal.addEventListener("mouseleave", function () {
      setTimeout(function () {
        if (!modal.matches(':hover') && !openModal.matches(':hover')) {
          hideModal();
        }
      }, 200);
    });

    modal.addEventListener("mouseleave", hideModal);
  }

  // Común: cerrar con botón
  closeModal.addEventListener("click", hideModal);
});







// FUNCIONA - Script personalizado para estilo de precio tipo Amazon
// Asegúrate de que la clase `.tee-price--current` no cambie en futuras actualizaciones de Teeinblue


function formatPriceDecimals(priceEl) {
  const text = priceEl.innerText.trim();
  const match = text.match(/^(\d+),(?:(\d+))(\s?€)$/);
  if (match) {
    priceEl.innerHTML = `${match[1]},<span class="price-decimals">${match[2]}</span>${match[3]}`;
  }
}

document.addEventListener("teeinblue-event-component-injected", function () {
  if (window.location.pathname.includes("/products/")) {
    const priceEl = document.querySelector('.tee-price--current');

    if (priceEl) {
      formatPriceDecimals(priceEl);

      const parent = priceEl.parentElement;
      if (parent) {
        const observer = new MutationObserver((mutations, obs) => {
          // Desconectamos el observer para evitar loops
          obs.disconnect();

          // Formateamos de nuevo si el nodo sigue existiendo
          const updatedPriceEl = parent.querySelector('.tee-price--current');
          if (updatedPriceEl) {
            formatPriceDecimals(updatedPriceEl);
          }

          // Volvemos a observar después de aplicar el cambio
          obs.observe(parent, { childList: true, subtree: true });
        });

        observer.observe(parent, { childList: true, subtree: true });
      }
    }
  }
});




/* FUNCIONA - SI EL PRODUCTO NO TIENE LA PALABRA "Personaliz" OCULTA EL BOTON DE PERSONALIZACIÓN Y UNA DIV QUE QUEDABA EN GRIS */

document.addEventListener("teeinblue-event-component-injected", function () {
  const titleElement = document.querySelector('h1'); // Ajusta si el título está en otro lugar
  const teeformheader = document.querySelector('.tee-form-header');
  const customizationForm = document.querySelector('.tee-customization-form');
  const previewButton = document.querySelector('.tee-btn.tee-btn--full.tee-btn--preview');


  if (titleElement) {
    const title = titleElement.innerText.toLowerCase();

    if (!title.includes("personaliz")) {
      if (customizationForm) {
        customizationForm.style.display = 'none';
      }
      if (previewButton) {
        previewButton.style.display = 'none';
      }
      if (teeformheader) {
        teeformheader.style.display = 'none';
      }
    }
  }
});

  




/* FUNCIONA - Cambia "Quantity" por "Cantidad" */

document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove = document.querySelector(".tee-quantity");
  const insertAfterElement = document.querySelector("#teeFormInputs");
  const titleElement = document.querySelector(".tee-quantity .tee-field__title.sr-only");
  
  if (elementToMove && insertAfterElement) {
    insertAfterElement.after(elementToMove);
    elementToMove.style.width = "150px";
  }
  
  if (titleElement) {
    titleElement.textContent = "Cantidad"; // Cambia "Quantity" por "Cantidad"
  }
});








/* FUNCIONA - FIX PRICE */

document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove = document.querySelector("#delivery-text");
  const insertAfterElement = document.querySelector(".tee-product-price");
  if (elementToMove && insertAfterElement) {
    insertAfterElement.after(elementToMove);
    elementToMove.style.width = "150px";
  }
});




// =====================================================
// TeeInBlue Guides (Mibblo) — CONFIG FIRST
// - Todo se define en GUIDES (por product.type)
// - Para añadir un tipo nuevo: añade un bloque en GUIDES
// - Mantiene el popup igual (inline styles como tu versión)
// =====================================================

/* =========================
   1) CONFIG (EDITA AQUÍ)
   ========================= */
const GUIDES = {
  // --- Posters ---
  posters: {
    enabled: true,

    // Cómo detectar este tipo (elige uno):
    // match: { exact: ["posters"] }  -> EXACTO
    // match: { includes: ["poster","póster","posters"] } -> contiene
    match: { includes: ["poster", "póster", "posters", "posters", "pósters"] },

    // Dónde poner el botón: al lado del título del campo
    fieldTitle: ["tamaño", "tamano", "size"],

    // UI
    buttonText: "Ver guía",
    iconClass: "las la-ruler",
    buttonFontSize: "13px",

    // Página a cargar
    url: "/pages/guia-wallart"
  },

  // --- Lienzos ---
  lienzos: {
    enabled: true,
    match: { includes: ["lienzo", "lienzos", "canvas"] },
    fieldTitle: ["tamaño", "tamano", "size"],
    buttonText: "Ver guía",
    iconClass: "las la-ruler",
    buttonFontSize: "13px",
    url: "/pages/guia-wallart"
  },

  // --- Camisetas ---
  camisetas: {
    enabled: true,
    match: { includes: ["camiseta", "camisetas", "tee", "t-shirt"] },
    fieldTitle: ["talla"],
    buttonText: "Guía de tallas",
    iconClass: "las la-ruler",
    buttonFontSize: "14px",
    url: "/pages/guia-camisetas"
  },

  // --- Sudaderas ---
  sudaderas: {
    enabled: true,
    match: { includes: ["sudadera", "sudaderas"] },
    fieldTitle: ["talla"],
    buttonText: "Guía de tallas",
    iconClass: "las la-ruler",
    buttonFontSize: "14px",
    url: "/pages/guia-sudaderas"
  },

  // --- Hoodies ---
  hoodies: {
    enabled: true,
    match: { includes: ["hoodie", "hoodies"] },
    fieldTitle: ["talla"],
    buttonText: "Guía de tallas",
    iconClass: "las la-ruler",
    buttonFontSize: "14px",
    url: "/pages/guia-hoodies"
  }
};

// Fallback opcional si un product.type no está en GUIDES
// (puedes dejar enabled:false para que no haga nada)
const DEFAULT_GUIDE = {
  enabled: false,
  fieldTitle: ["talla", "tamaño", "tamano", "size"],
  buttonText: "Guía",
  iconClass: "las la-info-circle",
  buttonFontSize: "13px",
  url: "/pages/guia-general"
};

/* =========================
   2) INIT (PERSISTENTE)
   ========================= */
(function initPersistentGuides() {
  const ROOT_SELECTORS = [
    "#tee-artwork-form",
    ".tee-customization-wrapper",
    ".tee-campaign",
    "body"
  ];

  function findRoot() {
    for (const sel of ROOT_SELECTORS) {
      const el = document.querySelector(sel);
      if (el) return el;
    }
    return document.body;
  }

  function runOnce() {
    const productTypeRaw = String(window.__mibbloProductType || "").trim();
    if (!productTypeRaw) return;

    const productType = productTypeRaw.toLowerCase();
    const optionTitleElements = document.querySelectorAll(".tee-option__title");
    if (!optionTitleElements.length) return;

    const guide = resolveGuide(productType);
    if (!guide || !guide.enabled) return;

    // Importante: NO hagas break si quieres que aparezca en más de un campo
    for (const optionTitleElement of optionTitleElements) {
      // Si TeeInBlue recrea el DOM, este flag se pierde, así que reinjecta bien
      if (optionTitleElement.dataset.guideInjected === "1") continue;

      const titleText = optionTitleElement.textContent.trim().toLowerCase();
      if (!matchesFieldTitle(titleText, guide.fieldTitle)) continue;

      optionTitleElement.dataset.guideInjected = "1";
      injectGuideButton(optionTitleElement, guide);

      // Si solo quieres una inserción por producto, deja el break
      break;
    }
  }

  function boot() {
    runOnce();

    // Observer SOLO una vez
    const root = findRoot();
    if (root.__mibbloGuideObserver === true) return;
    root.__mibbloGuideObserver = true;

    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type !== "childList" || !m.addedNodes?.length) continue;

        for (const node of m.addedNodes) {
          if (!(node instanceof Element)) continue;

          // Si entra algo que contiene títulos de opciones, reinyecta
          if (node.matches?.(".tee-option__title") || node.querySelector?.(".tee-option__title")) {
            runOnce();
            return;
          }
        }
      }
    });

    obs.observe(root, { childList: true, subtree: true });

    // Extra: por si TeeInBlue solo cambia textos/valores sin recrear nodos
    root.addEventListener(
      "change",
      (e) => {
        if (e.target && e.target.closest && e.target.closest(".tee-customization-wrapper")) {
          runOnce();
        }
      },
      true
    );
  }

  // TeeInBlue inyecta
  document.addEventListener("teeinblue-event-component-injected", boot);

  // Backup por si carga tarde
  document.addEventListener("DOMContentLoaded", boot);
  window.addEventListener("load", boot);
})();

/* =========================
   3) RESOLVER: qué config usar
   ========================= */
function resolveGuide(productTypeLower) {
  // Busca en GUIDES el primero que encaje
  for (const key of Object.keys(GUIDES)) {
    const g = GUIDES[key];
    if (!g || !g.enabled) continue;
    if (matchesProductType(productTypeLower, g.match)) return g;
  }
  return DEFAULT_GUIDE;
}

function matchesProductType(productTypeLower, match) {
  if (!match) return false;

  if (match.exact && Array.isArray(match.exact)) {
    return match.exact.some(v => String(v).toLowerCase() === productTypeLower);
  }

  if (match.includes && Array.isArray(match.includes)) {
    return match.includes.some(v => productTypeLower.includes(String(v).toLowerCase()));
  }

  return false;
}

function matchesFieldTitle(titleTextLower, list) {
  if (!Array.isArray(list) || !list.length) return false;
  return list.some(v => titleTextLower === String(v).toLowerCase());
}

/* =========================
   4) INYECTAR BOTÓN
   ========================= */
function injectGuideButton(optionTitleElement, guide) {
  const customDiv = document.createElement("div");
  // Reutiliza tu clase para que encaje con tus CSS actuales
  customDiv.className = "talla-custom talla-custom--fit";

  const icon = document.createElement("i");
  icon.className = guide.iconClass || "las la-ruler";

  const btn = document.createElement("button");
  btn.type = "button";
  btn.textContent = guide.buttonText || "Guía";

  // Mantén el look EXACTO como antes (inline)
  btn.style.background = "transparent";
  btn.style.color = "#3c3756";
  btn.style.border = "none";
  btn.style.cursor = "pointer";
  btn.style.textDecoration = "underline";
  btn.style.fontSize = guide.buttonFontSize || "13px";
  btn.style.padding = "0";
  btn.style.marginLeft = "2px";

  btn.onclick = function (event) {
    event.preventDefault();
    showPopupFromUrl(guide.url);
  };

  customDiv.appendChild(icon);
  customDiv.appendChild(btn);

  optionTitleElement.insertAdjacentElement("afterend", customDiv);
}

/* =========================
   5) POPUP ÚNICO (igual al tuyo)
   ========================= */
function showPopupFromUrl(dynamicUrl) {
  if (!dynamicUrl) return;

  // overlay
  const overlay = document.createElement("div");
  Object.assign(overlay.style, {
    position: "fixed",
    inset: "0",
    backgroundColor: "rgba(0,0,0,.6)",
    zIndex: "999"
  });

  // popup
  const popup = document.createElement("div");
  Object.assign(popup.style, {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    backgroundColor: "#f9f5f0",
    padding: "0",
    border: "0",
    borderRadius: "10px",
    boxShadow: "0 4px 6px rgba(0,0,0,.1)",
    zIndex: "1000",
    maxWidth: "800px",
    maxHeight: "90%",
    width: "95%",
    height: "fit-content",
    overflowY: "auto"
  });

  const popupContent = document.createElement("div");

  const closeButton = document.createElement("button");
  closeButton.textContent = "Cerrar";
  Object.assign(closeButton.style, {
    position: "absolute",
    right: "10px",
    marginTop: "10px",
    padding: "10px",
    backgroundColor: "#3c3756",
    borderRadius: "5px",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    zIndex: "9999"
  });

  const closePopup = () => {
    document.body.style.overflow = "";
    overlay.remove();
  };

  closeButton.onclick = closePopup;
  overlay.onclick = (e) => {
    if (e.target === overlay) closePopup();
  };

  popup.appendChild(closeButton);

  fetch(dynamicUrl)
    .then((response) => {
      if (!response.ok) throw new Error("Error al cargar la página");
      return response.text();
    })
    .then((html) => {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;

      const mainContent = tempDiv.querySelector("#MainContent");
      if (mainContent) {
        popupContent.innerHTML = mainContent.innerHTML;

        // limpia scripts y on* inline por si la guía los trae
        popupContent.querySelectorAll("script").forEach((s) => s.remove());
        ["onload", "onclick", "onchange", "oninput", "onerror", "onsubmit"].forEach((attr) => {
          popupContent.querySelectorAll("[" + attr + "]").forEach((n) => n.removeAttribute(attr));
        });

        // (legacy) cm/inches: no rompe si no existe
        const selector = popupContent.querySelector("#unit-selector");
        const cmRows = popupContent.querySelectorAll(".cm-row");
        const inchesRows = popupContent.querySelectorAll(".inches-row");

        const applyUnits = () => {
          const useCm = selector?.value === "cm";
          cmRows.forEach((row) => (row.style.display = useCm ? "" : "none"));
          inchesRows.forEach((row) => (row.style.display = useCm ? "none" : ""));
        };

        if (selector) {
          selector.addEventListener("change", applyUnits);
          applyUnits();
        }
      } else {
        popupContent.innerHTML = "<p>No se encontró el contenido de la guía.</p>";
      }

      popup.appendChild(popupContent);
    })
    .catch(() => {
      popupContent.innerHTML = `<p>No se pudo cargar el contenido de la guía desde la URL: <strong>${dynamicUrl}</strong></p>`;
      popup.appendChild(popupContent);
    });

  overlay.appendChild(popup);
  document.body.appendChild(overlay);
  document.body.style.overflow = "hidden";
}





// =====================================================
// Mibblo — Activar reordenación TeeInBlue (solo si el producto tiene el tag)
// -----------------------------------------------------
// Liquid define: window.__mibbloReorderTIB = true
// Si está activo:
//   • Añade la clase: .mibblo-reorder-tib al contenedor TeeInBlue
//   • El orden real de los bloques se controla SOLO con CSS (order)
//   • No mueve el DOM → no rompe TeeInBlue ni los cambios de variantes
// =====================================================
(function () {
  function enable() {
    if (window.__mibbloReorderTIB !== true) return;

    const root =
      document.querySelector("#tee-artwork-form") ||
      document.querySelector(".tee-customization-wrapper") ||
      document.querySelector(".tee-campaign") ||
      document.body;

    root.classList.add("mibblo-reorder-tib");
  }

  document.addEventListener("teeinblue-event-component-injected", enable);
  document.addEventListener("DOMContentLoaded", enable);
  window.addEventListener("load", enable);
})();






// =====================================================
// Mibblo — Evitar que TeeInBlue "salte" a su galería al cambiar TAMAÑO
// - No bloquea el cambio de radio (no preventDefault)
// - Solo corta propagación de click/pointerdown en la opción de tamaño
// =====================================================






/** VINCULADO A CAMBIO EN MAIN-PRODUCT.LIQUID
 * Reordena las miniaturas de la galería SOLO cuando:
 * - El producto requiere el tag `thumbs:reorder`
 * - La variante seleccionada es la PRIMERA (variante por defecto)
 *
 * Comportamiento:
 * - Mueve la miniatura con data-media-position="2" a la primera posición
 * - Deja que el propio tema active la imagen (sin tocar estados internos)
 *
 * Objetivo:
 * - Mostrar una imagen más atractiva al entrar al producto
 * - Evitar que al cambiar variante y recargar se fuerce una imagen incorrecta
 * 


 
document.addEventListener("DOMContentLoaded", () => {
  const wrap = document.querySelector('#GalleryThumbnails-[data-thumb-reorder="1"], [data-thumb-reorder="1"][id^="GalleryThumbnails-"]');
  if (!wrap) return;

  const defaultVariantId = wrap.dataset.thumbDefaultVariant;
  if (!defaultVariantId) return;

  const urlVariant = new URLSearchParams(window.location.search).get("variant");

  let currentVariantId = urlVariant;
  if (!currentVariantId) {
    const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (variantInput) currentVariantId = variantInput.value;
  }

  if (!currentVariantId || String(currentVariantId) !== String(defaultVariantId)) return;

  const ul = wrap.querySelector('ul[id^="Slider-Thumbnails-"].thumbnail-slider__list');
  if (!ul) return;

  if (ul.dataset.thumbReordered === "1") return;
  ul.dataset.thumbReordered = "1";

  const items = Array.from(ul.querySelectorAll("li.thumbnail-slider__item"));
  if (items.length < 2) return;

  const firstWanted = items.find(li => li.dataset.mediaPosition === "2");
  if (firstWanted) ul.insertBefore(firstWanted, ul.firstChild);

  requestAnimationFrame(() => {
    const btn = ul.querySelector("li.thumbnail-slider__item button.thumbnail");
    if (btn) btn.click();
  });
});
*/





// =====================================================
// Mibblo — Características por formato
// - Inserta "Puntos a destacar" ANTES del bloque Detalles
// - Reutiliza y recoloca la caja existente
// - Compatible con TeeInBlue dinámico
// - Observa cambios de .active
// =====================================================

;(function () {

  const FORMAT_VALUES = [
    "Póster",
    "Marco negro",
    "Marco madera",
    "Lienzo"
  ]

  const SHOW_ON_LOAD = true

  const BOX_ATTR = "data-mibblo-format-info"
  const TITLE_CLASS = "m-format-info-external-title"

  const LINES = {
    "Póster": [
      {
        text: "Papel Fine Art Premium de alto gramaje",
        type: "check"
      },
      {
               text: "Impresión fotográfica de calidad excepcional",
        type: "check"
      },
        {
               text: "Colores intensos y negros profundos",
        type: "check"
      },
      {
        text: "Embalaje reforzado",
        type: "check"
      },
      {
        text: "Envío desde España 24-48 h",
        type: "info"
      }
    ],

    "Lienzo": [
      {
        text: "Montado sobre bastidor de madera",
        type: "check"
      },
      {
        text: "Lienzo de alta calidad con textura",
        type: "check"
      },
      {
        text: "Calidad fotográfica",
        type: "check"
      },
      {
        text: "Listo para colgar",
        type: "info"
      }
    ],

    "Marco negro": [
      {
        text: "Marco negro minimalista con paspartú",
        type: "check"
      },
      {
        text: "Calidad fotográfica en papel premium (200 g/m²)",
        type: "check"
      },
      {
        text: "Protección frontal en plexiglass",
        type: "check"
      },
      {
        text: "Listo para colgar",
        type: "info"
      }
    ],

    "Marco madera": [
      {
        text: "Marco de madera natural con paspartú",
        type: "check"
      },
      {
        text: "Calidad fotográfica en papel premium (200 g/m²)",
        type: "check"
      },
      {
        text: "Protección frontal en plexiglass",
        type: "check"
      },
      {
        text: "Listo para colgar",
        type: "info"
      }
    ]
  }

  function textNorm(str) {
    return (str || "")
      .toString()
      .replace(/\s+/g, " ")
      .trim()
  }

  function getOptionTextFromInput(input, scope) {
    if (!input) return ""

    const root = scope || document

    if (input.id) {
      const escapedId = CSS.escape(input.id)

      const span = root.querySelector(
        'label[for="' + escapedId + '"] span'
      )

      if (span && textNorm(span.textContent)) {
        return textNorm(span.textContent)
      }

      const label = root.querySelector(
        'label[for="' + escapedId + '"]'
      )

      if (label && textNorm(label.textContent)) {
        return textNorm(label.textContent)
      }
    }

    const wrap = input.closest(".tee-radio")

    if (wrap) {
      const span = wrap.querySelector("label span")

      if (span && textNorm(span.textContent)) {
        return textNorm(span.textContent)
      }

      const label = wrap.querySelector("label")

      if (label && textNorm(label.textContent)) {
        return textNorm(label.textContent)
      }
    }

    if (textNorm(input.value)) {
      return textNorm(input.value)
    }

    return ""
  }

  function createBox() {
    const box = document.createElement("div")

    box.className = "m-format-info"
    box.setAttribute(BOX_ATTR, "1")
    box.hidden = true
    box.innerHTML = '<ul class="m-format-info__list"></ul>'

    return box
  }

  function findDetailsBlock() {
    const components = document.querySelectorAll("toggle-component")

    for (let i = 0; i < components.length; i++) {
      const component = components[i]

      const titles = component.querySelectorAll(
        "details summary .chm-toggle__button h2"
      )

      for (let j = 0; j < titles.length; j++) {
        const titleText = textNorm(titles[j].textContent).toLowerCase()

        if (titleText === "detalles") {
          return component
        }
      }
    }

    return null
  }

  function findExistingBox() {
    return document.querySelector(
      "[" + BOX_ATTR + '="1"]'
    )
  }

  function ensureBox(groupEl) {
    let box = findExistingBox()

    if (!box) {
      box = createBox()
    }

    const detailsBlock = findDetailsBlock()

    if (detailsBlock && detailsBlock.parentNode) {
      detailsBlock.parentNode.insertBefore(box, detailsBlock)
    } else if (!box.isConnected && groupEl) {
      groupEl.insertAdjacentElement("afterend", box)
    }

    return box
  }

  function ensureTitleAboveBox(box) {
    if (!box || !box.parentNode) return

    let title = document.querySelector("." + TITLE_CLASS)

    if (!title) {
      title = document.createElement("div")
      title.className = TITLE_CLASS
      title.textContent = "Puntos a destacar"
    }

    box.parentNode.insertBefore(title, box)
  }

  function setLinesAndShow(box, value) {
    const data = LINES[value]

    if (!data || !box) return

    const list = box.querySelector(".m-format-info__list")

    if (!list) return

    list.innerHTML = ""

    data.forEach(function (item) {
      const type = item.type === "info"
        ? "info"
        : "check"

      const li = document.createElement("li")

      li.className =
        "m-format-info__item m-format-info__item--" + type

      const icon = document.createElement("span")

      icon.className = "m-format-info__icon"
      icon.textContent = type === "info"
        ? "i"
        : "✓"

      const text = document.createElement("span")

      text.textContent = item.text

      li.appendChild(icon)
      li.appendChild(text)
      list.appendChild(li)
    })

    box.hidden = false
  }

  function isFormatGroup(groupEl) {
    if (!groupEl) return false

    const radios = groupEl.querySelectorAll(
      'input[type="radio"]'
    )

    if (!radios.length) return false

    let hits = 0

    for (let i = 0; i < FORMAT_VALUES.length; i++) {
      const wanted = FORMAT_VALUES[i]
      let found = false

      for (let j = 0; j < radios.length; j++) {
        const optionText = getOptionTextFromInput(
          radios[j],
          groupEl
        )

        if (optionText === wanted) {
          found = true
          break
        }
      }

      if (found) hits++
    }

    return hits >= 2
  }

  function getSelectedFormat(groupEl) {
    const active = groupEl.querySelector(
      '.tee-radio.active input[type="radio"]'
    )

    if (active) {
      const activeText = getOptionTextFromInput(
        active,
        groupEl
      )

      if (LINES[activeText]) {
        return activeText
      }
    }

    const checked = groupEl.querySelector(
      'input[type="radio"]:checked'
    )

    if (checked) {
      const checkedText = getOptionTextFromInput(
        checked,
        groupEl
      )

      if (LINES[checkedText]) {
        return checkedText
      }
    }

    const first = groupEl.querySelector(
      'input[type="radio"]'
    )

    if (first) {
      const firstText = getOptionTextFromInput(
        first,
        groupEl
      )

      if (LINES[firstText]) {
        return firstText
      }
    }

    return ""
  }

  function findFormatGroup() {
    const blocks = document.querySelectorAll(
      ".tee-option.tee-option--color.tee-block"
    )

    for (let i = 0; i < blocks.length; i++) {
      const block = blocks[i]
      const title = block.querySelector(".tee-option__title")

      if (
        title &&
        textNorm(title.textContent).toLowerCase() === "formato"
      ) {
        const group = block.querySelector(
          '.tee-option-inner[role="radiogroup"]'
        )

        if (group && isFormatGroup(group)) {
          return group
        }
      }
    }

    const groups = document.querySelectorAll(
      '.tee-option-inner[role="radiogroup"], ' +
      '.tee-row[role="radiogroup"]'
    )

    for (let i = 0; i < groups.length; i++) {
      if (isFormatGroup(groups[i])) {
        return groups[i]
      }
    }

    return null
  }

  function renderForGroup(groupEl) {
    if (!groupEl || !isFormatGroup(groupEl)) return

    const box = ensureBox(groupEl)

    ensureTitleAboveBox(box)

    const value = getSelectedFormat(groupEl)

    if (!value) return

    setLinesAndShow(box, value)
  }

  let activeObserver = null

  function observeActiveChanges(groupEl) {
    if (!groupEl) return

    if (groupEl.dataset.mibbloActiveObs === "1") {
      return
    }

    groupEl.dataset.mibbloActiveObs = "1"

    const schedule = function () {
      renderForGroup(groupEl)

      setTimeout(function () {
        renderForGroup(groupEl)
      }, 80)
    }

    const observer = new MutationObserver(function (mutations) {
      for (let i = 0; i < mutations.length; i++) {
        const mutation = mutations[i]

        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class" &&
          mutation.target &&
          mutation.target.classList &&
          mutation.target.classList.contains("tee-radio")
        ) {
          schedule()
          break
        }
      }
    })

    const radios = groupEl.querySelectorAll(".tee-radio")

    radios.forEach(function (radio) {
      observer.observe(radio, {
        attributes: true,
        attributeFilter: ["class"]
      })
    })

    activeObserver = observer
  }

  function init() {
    const group = findFormatGroup()

    if (!group) return

    if (SHOW_ON_LOAD) {
      renderForGroup(group)
    }

    observeActiveChanges(group)
  }

  // Reintenta hasta que TeeInBlue haya cargado.
  let tries = 0

  const timer = setInterval(function () {
    tries++

    init()

    if (findFormatGroup() || tries > 120) {
      clearInterval(timer)
    }
  }, 100)

  // Mantiene el listener change por compatibilidad.
  document.addEventListener("change", function (event) {
    const input = event.target

    if (!(input instanceof HTMLInputElement)) return
    if (input.type !== "radio") return

    const groupEl = input.closest(
      '.tee-option-inner[role="radiogroup"], ' +
      '.tee-row[role="radiogroup"]'
    )

    if (!groupEl) return

    renderForGroup(groupEl)

    setTimeout(function () {
      renderForGroup(groupEl)
    }, 80)
  })

  // Observa reinyecciones del DOM de TeeInBlue.
  const root =
    document.getElementById("tee-artwork-form") ||
    document.querySelector(".tee-customization-form")

  if (root) {
    const mutationObserver = new MutationObserver(
      function (mutations) {
        for (let i = 0; i < mutations.length; i++) {
          const mutation = mutations[i]

          if (
            !mutation.addedNodes ||
            !mutation.addedNodes.length
          ) {
            continue
          }

          for (
            let j = 0;
            j < mutation.addedNodes.length;
            j++
          ) {
            const node = mutation.addedNodes[j]

            if (!(node instanceof Element)) {
              continue
            }

            if (
              node.matches?.(
                ".tee-radio, .tee-option, .tee-option-inner"
              ) ||
              node.querySelector?.(
                ".tee-radio, .tee-option, .tee-option-inner"
              )
            ) {
              init()
              return
            }
          }
        }
      }
    )

    mutationObserver.observe(root, {
      childList: true,
      subtree: true
    })
  }

  // Por si el bloque Detalles carga después que TeeInBlue.
  const pageObserver = new MutationObserver(function () {
    const group = findFormatGroup()
    const details = findDetailsBlock()
    const box = findExistingBox()

    if (group && details) {
      renderForGroup(group)
    } else if (box && details && details.parentNode) {
      details.parentNode.insertBefore(box, details)
      ensureTitleAboveBox(box)
    }
  })

  pageObserver.observe(document.body, {
    childList: true,
    subtree: true
  })

})()






/*
=====================================================
Mibblo — Título de variante fuera de la card

Qué hace:
- Solo en productos con layout "mibblo-variant-cards"
- Detecta el grupo de variantes "Producto" (color-*)
- Lee el texto de cada variante
- Crea un <div class="mibblo-card-title"> debajo de cada card
- Soporta recargas dinámicas de TeeInBlue (MutationObserver)

Objetivo:
Mostrar el nombre de la variante fuera de la imagen/card.
=====================================================
*/

(function () {
  function enhance() {
    if (!document.body.classList.contains("mibblo-variant-cards")) return;

    const rows = document.querySelectorAll('.tee-option-inner[aria-labelledby="label-color"]');

    rows.forEach((row) => {
      const hasColorGroup = !!row.querySelector('input[type="radio"][name^="color-"]');
      if (!hasColorGroup) return;

      row.classList.add("mibblo-color-cards");

      row.querySelectorAll(".tee-radio.tee-radio--color").forEach((radio) => {
        if (radio.querySelector(".mibblo-card-title")) return;

        const label = radio.querySelector("label");
        if (!label) return;

        const span = label.querySelector("span");
        const text = (span && span.textContent && span.textContent.trim()) || label.getAttribute("title") || "";
        if (!text) return;

        const t = document.createElement("div");
        t.className = "mibblo-card-title";
        t.textContent = text;
        radio.appendChild(t);
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    enhance();
    const mo = new MutationObserver(enhance);
    mo.observe(document.body, { childList: true, subtree: true });
  });
})();








